import { Menu } from '../use-tool-bar';
import { historyMenuHook, historyMenuTempHook } from './history-menu-hook';
import { historyMenuMedium } from './history-menu-medium';
import { historyMenuSmall } from './history-menu-small';

export const historyMenu: Menu = {
  id: 'menu-history',
  variants: [
    { Element: historyMenuSmall, priority: 15 },
    { Element: historyMenuMedium({ hideLabel: true }), priority: 15 },
    { Element: historyMenuMedium({ hideLabel: false }), priority: 15 },
  ],
  currentVariant: 2,
  hook: historyMenuHook,
  tempHook: historyMenuTempHook,
};
